import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import "bootstrap/dist/css/bootstrap.min.css"
import '@fortawesome/fontawesome-free/js/all.js'
import "bootstrap"


createApp(App).use(store).use(router).use(i18n).mount('#app')
